/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import { Row, Col } from '@duxton-web/ui';
import { Handle, Position } from 'reactflow';
import exitIcon from 'img/exit.svg';
import infoIcon from 'img/info.svg';

export default memo(({ data, isConnectable }) => {
  return (
    <div>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <Row>
        <Col>
          <img src={exitIcon} height={'28px'} width={'28px'} alt={''} />
        </Col>
        <Col>
          <div className="title">
            <b>Exit Journey</b>
          </div>
        </Col>
      </Row>
      {data.showMetrics && data.processed_count > 0 && <div>
        <div className="divider" />
        <Row>
          <Col>
            <div className="progressTextHeader">
              Processed <img src={infoIcon} height={'12px'} width={'12px'} alt={''} />
            </div>
            <div className="progressTextContent">
              {((data.success_count / (data.totalCount || 0)) * 100).toFixed(1)} %
            </div>
          </Col>
        </Row>
      </div>}
    </div>

  );
});
